import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TechNewsItem } from 'src/app/models/sidebar-widgets.model';
import { SidebarWidgetsService } from 'src/app/services/sidebar-widgets.service';

// « Dernières actualités » : articles des sites tech (Frandroid, Numerama…) lus par l'API dans leurs flux RSS
// gratuits. Titre, miniature du flux et nom du site seulement : le clic ouvre l'article sur le site d'origine.
@Component({
    selector: 'app-tech-news-sidebar',
    templateUrl: './tech-news-sidebar.component.html',
    styleUrls: ['./tech-news-sidebar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TechNewsSidebarComponent implements OnInit {

  news: TechNewsItem[] = [];

  constructor(private widgets: SidebarWidgetsService) { }

  ngOnInit(): void {
    this.widgets.techNews().subscribe(news => this.news = news || []);
  }

  hidePicture(event: Event): void {
    (event.target as HTMLElement).style.visibility = 'hidden';
  }
}
